import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getRotateEquipmentListGroups } from '../../../api/rotate-equipment-list-groups';

export const getRotateEquipmentListGroupsAsync = createAsyncThunk(
  'rotateEquipmentListGroups/getRotateEquipmentListGroups',
  getRotateEquipmentListGroups
);

export interface RotateEquipmentListGroup {
  id: number;
  name: string;
  rotateEquipmentLists: {
    id: number;
    name: string;
    partNo: string;
    isCustomName: boolean;
  }[];
}

interface RotateEquipmentListGroupState {
  data: RotateEquipmentListGroup[];
}

const initialState: RotateEquipmentListGroupState = {
  data: []
};

export default createSlice({
  name: 'rotateEquipmentListGroups',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getRotateEquipmentListGroupsAsync.fulfilled,
      (state, action) => {
        state.data = action.payload.data;
      }
    );
  }
});
